var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "notice-container"
  }, [_c('div', {
    staticClass: "heading-icon",
    staticStyle: {
      "background-color": "#2a9d8f"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "14,2 14,8 20,8"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "13",
      "x2": "8",
      "y2": "13"
    }
  }), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "17",
      "x2": "8",
      "y2": "17"
    }
  }), _c('polyline', {
    attrs: {
      "points": "10,9 9,9 8,9"
    }
  })])]), _c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v(_vm._s(_vm.noticeTitle))]), _c('div', {
    staticClass: "notice-content",
    on: {
      "click": _vm.handleContentClick
    }
  }, [_vm.pageTitleTextContent ? _c('p', {
    staticClass: "notice-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.pageTitleTextContent)
    }
  }) : _c('p', {
    staticClass: "notice-subtitle"
  }, [_vm._v("攸關您的就診權益，在進行掛號前請詳細閱讀")]), _vm.data.blocks && _vm.data.blocks.length > 0 ? _c('div', _vm._l(_vm.data.blocks, function (block, index) {
    return _c('div', {
      key: index,
      staticClass: "notice-block"
    }, [block.type !== 'pageTitle' ? [block.type === 'textOnly' ? _c('div', {
      staticClass: "notice-item"
    }, [block.title ? _c('div', {
      staticClass: "notice-item-title"
    }, [_vm._v(_vm._s(block.title))]) : _vm._e(), block.content ? _c('div', {
      staticClass: "notice-item-content",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    }) : _vm._e()]) : block.type === 'titleAndText' ? _c('div', {
      staticClass: "notice-item"
    }, [block.title ? _c('div', {
      staticClass: "notice-item-title notice-item-title--title-and-text"
    }, [_vm._v(_vm._s(block.title))]) : _vm._e(), block.content ? _c('div', {
      staticClass: "notice-item-content notice-item-content--title-and-text",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    }) : _vm._e()]) : block.type === 'singleLine' ? _c('div', {
      staticClass: "notice-item"
    }, [_c('div', {
      staticClass: "notice-item-content",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    })]) : block.type === 'toggle' ? _c('details', {
      staticClass: "notice-item notice-accordion"
    }, [_c('summary', {
      staticClass: "notice-item-title"
    }, [_vm._v(_vm._s(block.title))]), _c('ul', {
      staticClass: "notice-list-items"
    }, _vm._l(block.items, function (item, i) {
      return _c('li', {
        key: i
      }, [_vm._v(_vm._s(item))]);
    }), 0)]) : block.type === 'image' ? _c('div', {
      staticClass: "notice-item"
    }, [block.title ? _c('div', {
      staticClass: "notice-item-title"
    }, [_vm._v(_vm._s(block.title))]) : _vm._e(), block.url ? _c('img', {
      attrs: {
        "src": block.url,
        "alt": block.title || 'Notice image'
      }
    }) : _vm._e(), block.content ? _c('div', {
      staticClass: "notice-item-content",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    }) : _vm._e()]) : block.type === 'file' ? _c('div', {
      staticClass: "notice-item"
    }, [block.title ? _c('div', {
      staticClass: "notice-item-title notice-item-title--file"
    }, [_vm._v(_vm._s(block.title))]) : _vm._e(), block.content ? _c('div', {
      staticClass: "notice-item-content notice-item-content--file",
      domProps: {
        "innerHTML": _vm._s(block.content)
      }
    }) : _vm._e()]) : _vm._e()] : _vm._e()], 2);
  }), 0) : _vm._e()]), _c('ImageLightBox', {
    ref: "globalLightbox"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }